import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useSendMessage() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({
      conversationId,
      body,
    }: {
      conversationId: string
      body: string
    }) => {
      const { data, error } = await supabase.rpc('send_chat_message', {
        _conversation_id: conversationId,
        _body: body,
      })
      if (error) throw error
      const result = data as {
        success?: boolean
        error?: string
        message_id?: string
      }
      if (result.error) throw new Error(result.error)
      return result
    },
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: ['conversation', vars.conversationId] })
      qc.invalidateQueries({ queryKey: ['conversations'] })
    },
  })
}
